// Khung "TẦN SUẤT CHẠY" dùng chung cho trang một kịch bản và trang chuỗi (05/10/2026, người dùng: "kịch bản chạy liên tục từ ngày nọ sang ngày
// kia — không có đặt tần suất à?"). Dùng lại lịch có sẵn của Boss (giờ, các thứ trong tuần, lệch ngẫu nhiên) — mỗi dòng là MỘT khung giờ; nhiều
// khung = nhiều lần/ngày; lặp lại mỗi ngày đã chọn = chạy liên tục nhiều ngày. Tạo / sửa / bật-tắt / xoá ngay tại trang. Lịch cũ (trang Lịch,
// Gói seeding) của cùng kịch bản cũng hiện ở đây; lịch của Gói seeding chỉ xem (sửa ở trang gói). Mọi chữ dựng bằng textContent.
import { api, errMsg } from "../api";
import { busy, clear, confirmBox, h, toast } from "../dom";
import type { Bot } from "../types";
import { dungKhungGioAi } from "../khung-gio-ai";
import { GIO_THAP_DIEM_MAC_DINH } from "../../../../src/shared/gio-cao-diem";

const TEN_THU = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"];
const TEN_THU_DAY = ["Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy", "Chủ nhật"];
const CA_TUAN = [1, 2, 3, 4, 5, 6, 7];

export interface LichDong {
  id: string; hhmm: string; tz: string; thu: number[]; lech: number; enabled: boolean; gioHomNay: string | null; lastRunDate: string | null; lastJobId: string | null;
  goiDungId: string | null; nguon: "kich_ban" | "chuoi" | "goi" | "lich"; sua: boolean; cheDo: string; botIds: string[]; botTen: string[];
}

export function thuChu(thu: number[]): string {
  const t = [...(thu.length ? thu : CA_TUAN)].sort((a, b) => a - b);
  return t.length === 7 ? "mỗi ngày" : t.map((x) => TEN_THU[x - 1]).join(" ");
}
const cheDoChu = (m: string): string => (m === "live" ? "Chạy thật" : m === "dry" ? "Chỉ định vị" : "Chạy thử (cũ)");

/**
 * Vẽ khung tần suất vào `box`. `duongDan` = "/api/kich-ban/<id>/lich" hoặc "/api/chuoi/<id>/lich". `layBots` = bot của CHỦ (để tick).
 * `goiY` = câu giải thích riêng (kịch bản / chuỗi). Trả { tai, huy }.
 */
export function taoKhungLich(box: HTMLElement, o: { duongDan: () => string; layBots: () => Bot[]; botMacDinh?: () => string[]; tieuDe: string; goiY: string; testId: string }): { tai: () => Promise<void>; huy: () => void } {
  let ds: LichDong[] = [];
  let loiTai: string | null = null;
  let daTai = false;
  let song = true;
  const formHost = h("div");

  const tai = async (): Promise<void> => {
    try { ds = (await api<{ lich: LichDong[] }>("GET", o.duongDan())).lich; loiTai = null; }
    catch (e) { loiTai = errMsg(e); }
    daTai = true;
    if (song) ve();
  };

  function dong(l: LichDong): HTMLElement {
    const bat = h("input", { type: "checkbox", checked: l.enabled, disabled: !l.sua, title: l.enabled ? "Khung giờ đang bật — bỏ tick để tạm tắt (không xoá)" : "Khung giờ đang tắt — tick để bật lại", "data-testid": "ls-bat" });
    bat.addEventListener("change", () => void (async () => {
      bat.disabled = true;
      try { await api("PATCH", `${o.duongDan()}/${encodeURIComponent(l.id)}`, { enabled: bat.checked }); toast(bat.checked ? `Đã bật khung ${l.hhmm}` : `Đã tắt khung ${l.hhmm}`); await tai(); }
      catch (e) { bat.checked = l.enabled; bat.disabled = false; toast(errMsg(e), "err"); }
    })());
    const nut: HTMLElement[] = [];
    if (l.sua) {
      const sua = h("button", { type: "button", class: "mini", title: "Sửa giờ, các ngày, độ lệch, bot, chế độ của khung giờ này", "data-testid": "ls-sua" }, "Sửa");
      sua.addEventListener("click", () => moForm(l));
      const xoa = h("button", { type: "button", class: "mini danger", title: "Xoá khung giờ này (lệnh đã chạy trước đó không ảnh hưởng) — có hộp xác nhận", "data-testid": "ls-xoa" }, "Xoá");
      xoa.addEventListener("click", () => void (async () => {
        if (!(await confirmBox({ title: `Xoá khung giờ ${l.hhmm}?`, text: `${thuChu(l.thu)} · ${cheDoChu(l.cheDo)} · ${l.botTen.join(", ")}`, okText: "Xoá", okTitle: "Xoá khung giờ ngay", danger: true }))) return;
        try { await api("DELETE", `${o.duongDan()}/${encodeURIComponent(l.id)}`); toast(`Đã xoá khung ${l.hhmm}`); await tai(); } catch (e) { toast(errMsg(e), "err"); }
      })());
      nut.push(sua, xoa);
    }
    const nguon = l.nguon === "goi" ? h("a", { href: `#/goi-seeding/${encodeURIComponent(l.goiDungId ?? "")}`, class: "small", title: "Lịch này do Gói seeding tạo — mở gói để sửa", "data-testid": "ls-nguon" }, "thuộc Gói seeding")
      : l.nguon === "lich" ? h("span", { class: "small muted", title: "Lịch tạo ở trang Lịch chạy cho cùng kịch bản này", "data-testid": "ls-nguon" }, "tạo ở trang Lịch") : null;
    return h("li", { class: `ls-dong${l.enabled ? "" : " muted"}`, "data-testid": "ls-dong", dataset: { id: l.id, hhmm: l.hhmm } },
      h("div", { class: "ls-gio" }, h("b", { "data-testid": "ls-hhmm" }, l.hhmm), h("span", { class: "small", "data-testid": "ls-thu" }, thuChu(l.thu)), l.lech > 0 ? h("span", { class: "small muted" }, `lệch ≤ ${l.lech} phút`) : null),
      h("div", { class: "ls-chi-tiet small" },
        h("span", { class: `tag${l.cheDo === "live" ? " err" : ""}`, "data-testid": "ls-che-do" }, cheDoChu(l.cheDo)), " ",
        h("span", { "data-testid": "ls-bot" }, l.botTen.join(", ")),
        l.enabled && l.gioHomNay ? h("div", { class: "muted", "data-testid": "ls-hom-nay", title: "Giờ chạy thực tế hôm nay = giờ đặt + độ lệch ngẫu nhiên của ngày hôm nay" }, `hôm nay chạy lúc ${l.gioHomNay}`) : null,
        l.lastRunDate ? h("div", { class: "muted" }, `lần cuối ${l.lastRunDate}`) : null, nguon),
      h("div", { class: "row ls-nut" }, h("label", { class: "inline", title: l.enabled ? "Đang bật" : "Đang tắt" }, bat, l.enabled ? "bật" : "tắt"), ...nut));
  }

  function moForm(cur: LichDong | null): void {
    clear(formHost);
    const gio = h("input", { type: "time", value: cur?.hhmm ?? GIO_THAP_DIEM_MAC_DINH, step: 60, title: "Giờ:phút bắt đầu chạy mỗi ngày đã chọn (giờ Việt Nam)", "data-testid": "ls-f-gio" });
    const thu = new Set<number>(cur?.thu.length ? cur.thu : CA_TUAN);
    const thuBox = h("div", { class: "row wrap", role: "group", "aria-label": "Các ngày trong tuần" });
    for (const d of CA_TUAN) {
      const cb = h("input", { type: "checkbox", checked: thu.has(d), title: TEN_THU_DAY[d - 1], dataset: { thu: String(d) }, "data-testid": "ls-f-thu" });
      cb.addEventListener("change", () => { if (cb.checked) thu.add(d); else thu.delete(d); });
      thuBox.append(h("label", { class: "inline", title: TEN_THU_DAY[d - 1] }, cb, TEN_THU[d - 1]));
    }
    const lech = h("input", { inputmode: "numeric", autocomplete: "off", value: String(cur?.lech ?? 0), title: "Mỗi ngày chạy trễ ngẫu nhiên 0 tới số phút này so với giờ đặt (0–60) để không đều tăm tắp như máy", "data-testid": "ls-f-lech" });
    // (08/10/2026, người dùng bỏ Nháp) lịch mới luôn chạy thật; lịch CŨ đặt chạy thử vẫn hiện lựa chọn "Chạy thử (cũ)" để đổi sang Chạy thật.
    const cheDo = h("select", { title: "Tới giờ bot làm THẬT; bước rủi ro cao vẫn dừng chờ duyệt", "data-testid": "ls-f-che-do" },
      ...(cur?.cheDo === "draft" ? [h("option", { value: "draft", selected: true }, "Chạy thử (cũ)")] : []), h("option", { value: "live", selected: cur?.cheDo !== "draft" }, "Chạy thật"));
    const kg = dungKhungGioAi({ layGio: () => gio.value, datGio: (v) => { gio.value = v; }, layThu: () => [...thu], layLech: () => Number(lech.value) || 0 });
    for (const e of [gio, lech]) { e.addEventListener("input", kg.capNhat); e.addEventListener("change", kg.capNhat); }
    thuBox.addEventListener("change", kg.capNhat);
    const chon = new Set<string>(cur?.botIds ?? o.botMacDinh?.() ?? []);
    const botBox = h("div", { class: "ls-bot-chon", "data-testid": "ls-f-bots" });
    const bots = o.layBots();
    for (const b of bots) {
      const cb = h("input", { type: "checkbox", checked: chon.has(b.id), title: `Tick = khung giờ này chạy trên “${b.name}”`, dataset: { botId: b.id }, "data-testid": "ls-f-bot" });
      cb.addEventListener("change", () => { if (cb.checked) chon.add(b.id); else chon.delete(b.id); });
      botBox.append(h("label", { class: "inline", title: `Tick = khung giờ này chạy trên “${b.name}”` }, cb, b.name, b.online ? null : h("span", { class: "tag", title: "Bot đang ngoại tuyến; tới giờ mà vẫn ngoại tuyến thì lần đó bị bỏ qua (có thông báo)" }, "ngoại tuyến")));
    }
    if (!bots.length) botBox.append(h("p", { class: "muted small" }, "Chưa có bot nào — ghép cặp bot ở trang Bot trước."));
    const bat = h("input", { type: "checkbox", checked: cur ? cur.enabled : true, title: "Tick = khung giờ có hiệu lực ngay sau khi lưu", "data-testid": "ls-f-bat" });
    const loi = h("div", { class: "err-box", hidden: true, "data-testid": "ls-f-loi" });
    const luu = h("button", { type: "button", class: "pri", title: cur ? "Lưu thay đổi của khung giờ này" : "Thêm khung giờ chạy với các thiết lập trên", "data-testid": "ls-f-luu" }, cur ? "Lưu khung giờ" : "Thêm khung giờ");
    const huy = h("button", { type: "button", title: "Đóng, không lưu", "data-testid": "ls-f-huy" }, "Huỷ");
    huy.addEventListener("click", () => clear(formHost));
    luu.addEventListener("click", () => void busy(luu, "Đang lưu…", async () => {
      loi.hidden = true;
      const ds2: string[] = [];
      if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(gio.value)) ds2.push("Giờ phải có dạng HH:MM");
      if (!thu.size) ds2.push("Chọn ít nhất một ngày trong tuần");
      const lv = lech.value.trim() || "0";
      if (!/^\d{1,2}$/.test(lv) || Number(lv) > 60) ds2.push("Lệch ngẫu nhiên phải là số nguyên 0–60 phút");
      if (!chon.size) ds2.push("Chưa tick bot nào");
      if (ds2.length) { loi.textContent = ds2.join(" · "); loi.hidden = false; return; }
      const body = { hhmm: gio.value, thu: [...thu].sort((a, b) => a - b), lech: Number(lv), cheDo: cheDo.value, botIds: [...chon], enabled: bat.checked };
      try {
        if (cur) await api("PATCH", `${o.duongDan()}/${encodeURIComponent(cur.id)}`, body);
        else await api("POST", o.duongDan(), body);
        toast(cur ? `Đã lưu khung ${body.hhmm}` : `Đã thêm khung ${body.hhmm}`);
        clear(formHost);
        await tai();
      } catch (e) { loi.textContent = errMsg(e); loi.hidden = false; }
    }));
    formHost.append(h("div", { class: "ls-form", "data-testid": "ls-form" },
      h("div", { class: "field-row" }, h("label", { class: "f" }, h("span", {}, "Giờ chạy"), gio), h("label", { class: "f" }, h("span", {}, "Lệch ngẫu nhiên (phút)"), lech), h("label", { class: "f" }, h("span", {}, "Chế độ"), cheDo)),
      kg.el,
      h("div", { class: "f" }, h("span", { class: "f-nhan" }, "Các ngày"), thuBox),
      h("div", { class: "f" }, h("span", { class: "f-nhan" }, "Bot"), botBox),
      h("label", { class: "inline", title: "Tick = khung giờ có hiệu lực ngay" }, bat, "Bật ngay"),
      loi, h("div", { class: "row" }, luu, huy)));
    gio.focus();
  }

  // Khung (thẻ, tiêu đề, nút thêm, chỗ form) dựng MỘT lần; mỗi lần tải lại chỉ thay danh sách — thẻ không bị thay giữa chừng (không nhảy cuộn/mất
  // tiêu điểm khi người dùng đang thao tác).
  const them = h("button", { type: "button", class: "mini pri", title: "Thêm một khung giờ chạy (mỗi khung = một lần/ngày vào các ngày đã chọn)", "data-testid": "ls-them" }, "＋ Thêm khung giờ");
  them.addEventListener("click", () => moForm(null));
  const ds2 = h("ul", { class: "ls-ds", "data-testid": "ls-ds" });
  box.append(h("div", { class: "card ls-the", "data-testid": o.testId },
    h("div", { class: "row between wrap" }, h("h3", {}, o.tieuDe), them),
    h("p", { class: "small muted" }, o.goiY),
    ds2, formHost));
  function ve(): void {
    clear(ds2);
    if (!daTai) ds2.append(h("li", { class: "muted small" }, "Đang tải…"));
    else if (loiTai) ds2.append(h("li", { class: "err-box" }, `Không tải được lịch: ${loiTai}`));
    else if (!ds.length) ds2.append(h("li", { class: "empty small", "data-testid": "ls-trong" }, "Chưa đặt tần suất — chỉ chạy khi bạn bấm."));
    else for (const l of ds) ds2.append(dong(l));
  }
  ve();
  void tai();
  return { tai, huy: () => { song = false; } };
}
